import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { AccountHooksService } from '../account-hooks.service';
import { ObjectsManagerService } from '../../objects-manager/services/objects-manager.service';
import { CustomObject } from 'app/shared/modules/custom-objects/custom-objects.types';
import { AccountService } from 'app/core';

@Component({
  selector: 'add-account-hook',
  templateUrl: './add-account-hook.component.html',
  styleUrls: ['./add-account-hook.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AddAccountHookComponent implements OnInit {
  createFolderForm: UntypedFormGroup;
  customObjects: CustomObject[] = [];
  objects: CustomObject[] = [];
  hookNames = [
    'before_create',
    'after_create',
    'before_save',
    'after_save',
    'before_destroy',
    'after_destroy',
    'after_publish_excel',
    'after_integration_sync',
    'after_commit_on_create',
    'after_commit_on_update',
    'after_commit_on_create_or_update',
  ];

  /**
   * Constructor
   *
   * @param {MatDialogRef} matDialogRef
   * @param {FormBuilder} _formBuilder
   */
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public matDialogRef: MatDialogRef<AddAccountHookComponent>,
    private _formBuilder: UntypedFormBuilder,
    private _accountHooksService: AccountHooksService,
    private readonly objectsManagerService: ObjectsManagerService,
    private readonly accountService: AccountService,
  ) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Create the form
    this.createFolderForm = this._formBuilder.group({
      hook_name: ['', [Validators.required]],
      object_type: ['', [Validators.required]],
    });

    //RRS: hooks do not currently support custom objects
    this.getCustomObjects();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Save and close
   */
  saveAndClose(): void {
    // Save the message as a draft
    this.saveAsDraft();

    // Close the dialog
    this.matDialogRef.close();
  }

  /**
   * Discard the message
   */
  discard(): void {
    this.matDialogRef.close();
  }

  /**
   * Save the message as a draft
   */
  saveAsDraft(): void {}

  /**
   * Send the message
   */
  save(): void {
    let accountHook = this.createFolderForm.value;

    this._accountHooksService.saveAccountHook(accountHook).subscribe((af) => {
      this.matDialogRef.close();
    });
  }

  private get accountId(): number {
    return Number(this.accountService.getCurrentAccount().id);
  }

  trackByFn(index: number, item: any): number {
    return item.id || index;
  }

  getCustomObjects(): void {
    this.objectsManagerService.get(this.accountId).subscribe((objects) => {
      this.objects = objects;
      this.customObjects = objects.filter((object) => object?.id);
    });
  }
}
